// /login — the eager entry screen: a depth-1 wire over the module-owned form
// (Law F1; @erp/module-auth/fe/sign-in carries the opaque-denial discipline,
// the step-up branch and the human check). Only the console's copy lives here.
import { SignInScreen } from "@erp/module-auth/fe/sign-in";

export function LoginScreen() {
  return (
    <SignInScreen
      title="SHIPPRA ERP"
      subtitle="Sign in to the operator console."
      emailHint="The operator account your administrator provisioned — personal addresses carry no console access."
      passwordHint="Case-sensitive. Sign-in failures never say which factor was wrong; if both look right, ask your administrator for a reset."
    />
  );
}
